@if (isSystems) {
  <lib-footer></lib-footer>
}

@if (!isSystems) {
  <div class="footer d-print-none z-3">
    <span class="links">
      <a routerLink="/cookie">
        {{'Cookie.Name' | translate}}
      </a>
    </span>
  </div>
}